export default "__VITE_ASSET__DKtC6N$N__"